import { images } from '../../../Constants/ImageUrls';
import { PrepaidXOffStyled } from './styled';

function PrepaidXOff() {
  return (
    <PrepaidXOffStyled>
      <div>
        <img src={images.percentOffIcon} alt="" />
      </div>
      <div className="textWrapper">
        <div className="title">Extra 5% OFF on online payments</div>
        <div className="description">
          You can get extra 5% OFF upto ₹49 on your every diaper order
        </div>
      </div>
    </PrepaidXOffStyled>
  );
}

export default PrepaidXOff;
